import { Box, styled } from '@mui/material';

import { doNotForwardTheseProps } from '@/styles/utils';

import { DocumentStatus } from '@/types/document';

export const ProgressDot = styled('div', {
  shouldForwardProp: doNotForwardTheseProps(
    'isHighlight',
    'isOnDark',
    'activeColor',
    'inactiveColor',
  ),
})<{
  isHighlight?: boolean;
  isOnDark?: boolean;
  activeColor?: string;
  inactiveColor?: string;
}>(({ theme, isHighlight, isOnDark, activeColor, inactiveColor }) => ({
  borderRadius: 24,
  height: 8,
  width: 16,
  ...(isOnDark
    ? {
        backgroundColor: isHighlight
          ? activeColor || theme.palette.common.white
          : inactiveColor || theme.palette.grey[500],
      }
    : {
        backgroundColor: isHighlight
          ? activeColor || theme.palette.primaries[400]
          : inactiveColor || theme.palette.grey[300],
      }),
}));

export const StatusProgressDot = styled('div', {
  shouldForwardProp: doNotForwardTheseProps('status'),
})<{
  status?: DocumentStatus;
}>(({ theme, status }) => ({
  borderRadius: 24,
  height: 8,
  width: 16,
  ...(status === DocumentStatus.Approved || status === DocumentStatus.Completed
    ? {
        backgroundColor: theme.palette.green[500],
      }
    : status === DocumentStatus.InReview
      ? {
          backgroundColor: theme.palette.orange[400],
        }
      : status === DocumentStatus.Rejected
        ? {
            backgroundColor: theme.palette.common.white,
            border: `2px solid ${theme.palette.red[500]}`,
          }
        : {
            backgroundColor: theme.palette.grey[300],
          }),
}));

export const SelectionIndicatorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.5),
  width: '100%',
}));

export const SelectionIndicatorDot = styled(Box, {
  shouldForwardProp: doNotForwardTheseProps(
    'isActive',
    'dotColor',
    'activeColor',
  ),
})<{ isActive?: boolean; dotColor?: string; activeColor?: string }>(
  ({ theme, isActive, dotColor, activeColor }) => ({
    borderRadius: 7,
    height: 8,
    width: isActive ? 24 : 8,
    backgroundColor: isActive
      ? activeColor || theme.palette.primaries[500]
      : dotColor || theme.palette.primaries[300],
    transition: theme.transitions.create(['background-color', 'width']),
  }),
);
